import { useEffect, useState } from "react";
import api from "./api";
import React from "react";
import Notification from "./Notification";

export default function MenuImages() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [note, setNote] = useState({ message: "", type: "" });

  // English + German titles and files
  const [titleEN, setTitleEN] = useState("");
  const [titleDE, setTitleDE] = useState("");
  const [fileEN, setFileEN] = useState(null);
  const [fileDE, setFileDE] = useState(null);

  // Load images
  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/menu-images");
      // Sort by creation time ascending
      setRows(Array.isArray(data) ? data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) : []);
    } catch (e) {
      setNote({ message: e?.response?.data?.error || "Failed to load images ❌", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  // Upload handler
  const uploadImages = async (e) => {
    e.preventDefault();
    setNote({ message: "", type: "" });
    try {
      if (!titleEN.trim() && !titleDE.trim())
        return setNote({ message: "At least one title is required ❌", type: "error" });
      if (!fileEN && !fileDE)
        return setNote({ message: "Please choose at least one image ❌", type: "error" });

      if (fileEN && titleEN.trim()) {
        const fdEN = new FormData();
        fdEN.append("title", titleEN.trim());
        fdEN.append("language", "en");
        fdEN.append("file", fileEN);
        await api.post("/api/menu-images", fdEN, { headers: { "Content-Type": "multipart/form-data" } });
      }

      if (fileDE && titleDE.trim()) {
        const fdDE = new FormData();
        fdDE.append("title", titleDE.trim());
        fdDE.append("language", "de");
        fdDE.append("file", fileDE);
        await api.post("/api/menu-images", fdDE, { headers: { "Content-Type": "multipart/form-data" } });
      }

      // Clear inputs after upload
      setTitleEN(""); setTitleDE("");
      setFileEN(null); setFileDE(null);
      if (document.getElementById("fileEN")) document.getElementById("fileEN").value = "";
      if (document.getElementById("fileDE")) document.getElementById("fileDE").value = "";

      await load();
      setNote({ message: "Uploaded successfully ✅", type: "success" });
    } catch (e) {
      console.error(e);
      setNote({ message: e?.response?.data?.error || "Upload failed ❌", type: "error" });
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this image?")) return;
    setNote({ message: "", type: "" });
    try {
      await api.delete(`/api/menu-images/${id}`);
      await load();
      setNote({ message: "Deleted successfully ✅", type: "success" });
    } catch (e) {
      setNote({ message: e?.response?.data?.error || "Delete failed ❌", type: "error" });
    }
  };

  // Group images into pairs by creation time (EN+DE together)
  const pairs = [];
  let tempPair = [];

  rows.forEach((img, idx) => {
    if (!tempPair.length) {
      tempPair.push(img);
    } else {
      const prev = tempPair[0];
      const diff = Math.abs(new Date(img.createdAt) - new Date(prev.createdAt)) / 1000;
      // If more than 5 seconds difference, start new pair
      if (diff > 5) {
        pairs.push(tempPair);
        tempPair = [img];
      } else {
        tempPair.push(img);
      }
    }
    if (idx === rows.length - 1) pairs.push(tempPair);
  });

  let sl = 1;

  return (
    <div style={{ display: "grid", gap: 20, color: "#222" }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, textAlign: "center", color: "#d4a017" }}>
        Midday Discount Images (English & German)
      </h2>

      {/* Upload form */}
      <form onSubmit={uploadImages} style={{ display: "grid", gap: 14, border: "1px solid #ddd", borderRadius: 10, padding: 18, background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
          <div style={{ background: "#fffdf7", padding: 14, borderRadius: 10, border: "1px solid #eee", boxShadow: "0 2px 6px rgba(0,0,0,0.04)" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: 15, fontWeight: 600, color: "#b8860b" }}>English Version 🇬🇧</h3>
            <label style={{ fontSize: 12, display: "block", marginTop: 8, color: "#555" }}>Title (EN)</label>
            <input value={titleEN} onChange={(e) => setTitleEN(e.target.value)} style={{ padding: 8, border: "1px solid #ccc", borderRadius: 6, width: "100%", marginTop: 4, background: "#fdfdfd" }} placeholder="Lunch Offer" />
            <label style={{ fontSize: 12, display: "block", marginTop: 8, color: "#555" }}>Image (EN)</label>
            <input id="fileEN" type="file" accept="image/*" onChange={(e) => setFileEN(e.target.files?.[0] || null)} style={{ marginTop: 6, fontSize: 12 }} />
          </div>

          <div style={{ background: "#fffdf7", padding: 14, borderRadius: 10, border: "1px solid #eee", boxShadow: "0 2px 6px rgba(0,0,0,0.04)" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: 15, fontWeight: 600, color: "#b8860b" }}>German Version 🇩🇪</h3>
            <label style={{ fontSize: 12, display: "block", marginTop: 8, color: "#555" }}>Title (DE)</label>
            <input value={titleDE} onChange={(e) => setTitleDE(e.target.value)} style={{ padding: 8, border: "1px solid #ccc", borderRadius: 6, width: "100%", marginTop: 4, background: "#fdfdfd" }} placeholder="Mittagsangebot" />
            <label style={{ fontSize: 12, display: "block", marginTop: 8, color: "#555" }}>Image (DE)</label>
            <input id="fileDE" type="file" accept="image/*" onChange={(e) => setFileDE(e.target.files?.[0] || null)} style={{ marginTop: 6, fontSize: 12 }} />
          </div>
        </div>
        <button style={{ padding: "10px 16px", borderRadius: 6, background: "#d4a017", color: "#fff", border: "none", fontWeight: 600, cursor: "pointer", marginTop: 8, width: "fit-content" }}>Upload</button>
      </form>

      {/* Image table with pair-based SL */}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8, minWidth: 400 }}>
          <thead>
            <tr style={{ background: "#f6f3ee" }}>
              <th style={th}>SL</th>
              <th style={th}>Title</th>
              <th style={th}>Language</th>
              <th style={th}>Preview</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" style={tdCenter}>Loading…</td></tr>
            ) : pairs.length === 0 ? (
              <tr><td colSpan="5" style={tdCenter}>No images yet.</td></tr>
            ) : (
              pairs.map((pair, idx) => {
                const enImg = pair.find(i => i.language === "en");
                const deImg = pair.find(i => i.language === "de");

                return (
                  <React.Fragment key={idx}>
                    {enImg && (
                      <tr>
                        <td style={td} rowSpan={deImg ? 2 : 1}>{idx + 1}</td>
                        <td style={td}>{enImg.title}</td>
                        <td style={td}>EN</td>
                        <td style={td}><button style={btnView} onClick={() => window.open(enImg.url, "_blank")}>View</button></td>
                        <td style={td}><button style={btnDanger} onClick={() => remove(enImg._id)}>Delete</button></td>
                      </tr>
                    )}
                    {deImg && (
                      <tr>
                        <td style={td}>{deImg.title}</td>
                        <td style={td}>DE</td>
                        <td style={td}><button style={btnView} onClick={() => window.open(deImg.url, "_blank")}>View</button></td>
                        <td style={td}><button style={btnDanger} onClick={() => remove(deImg._id)}>Delete</button></td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Floating notification */}
      {note.message && (
        <div style={{
          position: "fixed",
          bottom: 30,
          right: 30,
          background: note.type === "error" ? "#b00020" : "#d4a017",
          color: note.type === "error" ? "#fff" : "#111",
          padding: "12px 20px",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
        }}>
          {note.message}
        </div>
      )}
    </div>
  );
}

// ===== STYLES =====
const th = { textAlign: "left", padding: "10px 8px", borderBottom: "1px solid #ddd", fontWeight: 700, color: "#d4a017", whiteSpace: "nowrap" };
const td = { padding: "10px 8px", borderBottom: "1px solid #eee", verticalAlign: "middle", color: "#333" };
const tdCenter = { ...td, textAlign: "center", color: "#666" };
const btnView = { padding: "6px 10px", borderRadius: 6, background: "#007bff", color: "#fff", border: "none", cursor: "pointer" };
const btnDanger = { padding: "6px 10px", borderRadius: 6, background: "#c62828", color: "#fff", border: "none", cursor: "pointer" };
